module.exports = __webpack_public_path__ + "img/Coppa.8a84c559.png";